module.exports = __webpack_public_path__ + "img/Group77.0142a54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Group77.png
// module id = Zhg+
// module chunks = 1